/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerInitializeDocumentMutationResponse, DocumentUseCasesControllerInitializeDocument400, DocumentUseCasesControllerInitializeDocument401, DocumentUseCasesControllerInitializeDocument403 } from "../../models/documentUseCasesController/DocumentUseCasesControllerInitializeDocument";

function getDocumentUseCasesControllerInitializeDocumentUrl() {
  const res = { method: 'POST', url: `/api/v1/documents/initializations` as const }  
  return res
}

/**
 * @description Initializes a Document record for a file: creates the document, sets up DOCUMENT_INITIALIZATION processing, runs document setup + drawing detection + process routing. Idempotent — detects prior work and skips/reprocesses appropriately. LOCAL mode invokes synchronously and returns the result; WORKER mode enqueues a job.
 * @summary Create a document initialization operation
 * {@link /api/v1/documents/initializations}
 */
export async function documentUseCasesControllerInitializeDocument(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentUseCasesControllerInitializeDocumentMutationResponse, ResponseErrorConfig<DocumentUseCasesControllerInitializeDocument400 | DocumentUseCasesControllerInitializeDocument401 | DocumentUseCasesControllerInitializeDocument403>, unknown>({ method : "POST", url : getDocumentUseCasesControllerInitializeDocumentUrl().url.toString(), ... requestConfig })  
  return res.data
}